import styles from './DirectDepositInfo.scss';

const DirectDepositInfo = () => (
    <div className={styles.container}>
        <div className={styles.item}>
            <div className={styles['item__icon--dollar']} />
            <div className={styles.item__text}>
                Access your credit limit and earn higher credit limits over time
            </div>
        </div>
        <div className={styles.item}>
            <div className={styles['item__icon--credit']} />
            <div className={styles.item__text}>
                Build credit through automatic payments from your direct
                deposit*
            </div>
        </div>
    </div>
);

export default DirectDepositInfo;
